<template>
  <div class="home">
    <component :is="headerComponent"/>

    <router-view :class="ua == 'pc' ? 'panel-pc' : 'panel-mobile'"/>

    <component :is="footerComponent"/>
  </div>
</template>

<script>
  import PCHeader from '@/components/pc/Header'
  import MobileHeader from '@/components/mobile/Header'

  import PCFooter from '@/components/pc/Footer'
  import MobileFooter from '@/components/mobile/Footer'

  export default {
    data() {
      return {
     
      }
    },

    computed: {
      headerComponent() {
        return this.ua == 'pc' ? PCHeader : MobileHeader
      },

      footerComponent() {
        return this.ua == 'pc' ? PCFooter : MobileFooter
      },
    },

    created() {
      // 检测用户代理
      const userAgent = navigator.userAgent
      const isMobile = /mobile/i.test(userAgent) || /android/i.test(userAgent) || /ios/i.test(userAgent)
      this.ua = isMobile ? 'mobile' : 'pc'
      localStorage.setItem("ua", this.ua)
    }
  }
</script>

<style lang="scss" scoped>
  .home {
    .panel-pc {
      margin-top: 80px; // header fixed 占据高度
    }

    .panel-mobile {
      margin-top: 60px; // header fixed 占据高度
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/Home.vue